import { IApplicationState } from 'app/types/types';
import { connect } from 'react-redux';
import {
    getIsUserEssentialPlanOnly
} from '../../../../../../../../store/model/authUser/selectors/getIsUserEssentialPlanOnly';
import { TemplateSection } from '../../components/TemplateSection/TemplateSection';
import { ITemplateSectionFields } from '../../components/TemplateSection/types';
import { ESettingsSectionType } from '../../../../../../base/components/SettingsSection/types';
import { getSectionType } from '../../../../selectors/getSectionType';
import { ITemplateSectionHOCProps } from './types';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: ITemplateSectionHOCProps
): ITemplateSectionFields => {
    const sectionType = getSectionType(state, boardId, null, 'allowCreateBoard');
    const isDisallow = sectionType === ESettingsSectionType.DISALLOW;
    const isShow = (sectionType === ESettingsSectionType.DEFAULT || isDisallow);
    return {
        isEssentialFeature: getIsUserEssentialPlanOnly(state),
        isShow,
    };
};

export const TemplateSectionHOC = connect(
    mapStateToProps,
    null
)(TemplateSection);

TemplateSectionHOC.displayName = 'TemplateSectionHOC';
